import toast from 'react-hot-toast';

import { BankAccountVerifyFormikValues } from '@repo/ui/overlay';
import { FormikProps } from 'formik';

export function controlBankAccountVerifyErrorCode(
  code: string,
  verification: FormikProps<BankAccountVerifyFormikValues>
) {
  switch (code) {
    case 'NAME_AND_REGISTRATION_NUMBER_MISMATCH':
      verification.setFieldError('userRegistrationNumber', '정확한 주민등록번호를 입력해 주세요.');
      break;
    case 'ACCOUNT_NUMBER_MISMATCH':
      verification.setFieldError('accountNumber', '정확한 계좌번호를 입력해 주세요.');
      break;
    case 'ACTUAL_NAME_MISMATCH':
      verification.setFieldError('name', '본인 인증 명의와 동일한 실명을 입력해 주세요.');
      break;
    case 'ACCOUNT_HOLDER_NAME_MISMATCH':
      verification.setFieldError('accountNumber', '본인 명의의 계좌를 입력해 주세요.');
      break;
    case 'NOT_EXIST_USER_BANK_ACCOUNT_VERIFICATION':
    case 'NOT_EXIST_USER_IDENTITY_VERIFICATION':
    case 'INVALID_FINGERPRINT_REQUEST':
      toast.error(`계좌 인증에 실패했습니다. ${code}`);
      break;
    default:
      toast.error(`계좌 인증에 실패했습니다. ${code}`);
      break;
  }
}
